export const PersonStatus = {
  ApprovalPending: 1,
  Active: 2,
  InActive: 3,
  Rejected: 4,
};
